import React from 'react';
import { Navigate, useOutlet } from 'react-router-dom';

import LoadingGlobal from '@components/loadingIntro/LoadingGlobal';
import AppTheme from '@core/AppTheme';
import { useAppSelector } from '@core/hooks/appHooks';
import { RoutingViews, routingPaths } from '@core/services/routingService';
import { selectFirestoreUser, selectIsFetchingFirestoreUser } from '@core/store/userSlice/userSlice';
import { useAuth } from '@providers/authProvider';
import { DemmiHelpers, Logger } from '@subhanhabib/demmilib';

const AccountSetupRoute: React.FC = () => {
  const { user } = useAuth();
  const outlet = useOutlet();
  const firestoreUser = useAppSelector(selectFirestoreUser);
  const isFetchingFirestoreUser = useAppSelector(selectIsFetchingFirestoreUser);
  Logger({ objs: { isFetchingFirestoreUser, user, firestoreUser }, collapsed: false }, AccountSetupRoute);

  return isFetchingFirestoreUser ? (
    <LoadingGlobal isMounted={true} />
  ) : !firestoreUser ? (
    <Navigate to="/" />
  ) : DemmiHelpers.Customer.isSetupComplete(firestoreUser) ? (
    <Navigate to={routingPaths[RoutingViews.HOME]} />
  ) : user ? (
    <>
      <React.Fragment>
        <AppTheme isLogin={false} />
        {outlet}
      </React.Fragment>
    </>
  ) : (
    <Navigate to="/" />
  );
};
export default AccountSetupRoute;
